import {
  SAVE_ACCOUNT_ID,
  SAVE_PHONE_NUMBER,
  SAVE_ACCOUNT_SETTINGS,
  SAVE_ACCOUNT_SETTINGS_PROGRESS,
  SAVE_ACCOUNT_SETTINGS2,
  SAVE_ACCOUNT_SETTINGS2_FAILER
} from '../constants/actionTypes';
import {
  STATUS_OK} from '../constants/reponseTypes';
import { SAVE_SETTINGS_URL,
         SETTINGS_URL} from '../constants/restURLs';
import { fetchApi } from '../api';
import { push } from 'react-router-redux';
import {alertFailed, alertSuccess} from './AlertActions';
import { showLoadingIndicator } from './loginActions';

export function saveSettings(accountId,
                             pincode,
                             licensePlate,
                             email) {

  return function (dispatch) {
    dispatch( showLoadingIndicator(true) );
    let lang = localStorage.getItem('lang');
    let params = "accountId=" + accountId
               + "&email=" + email
               + "&password=" + pincode
               + "&licensePlate=" + licensePlate
               + "&lgeCode=" + lang;

    let settings = {
      personal:{
        email: email,
        password: pincode,
        licensePlate: licensePlate
      }
    };

    console.log("params", params);
    let callbacks = {
      onSuccess: (response) => {
        dispatch( showLoadingIndicator(false) );
        console.log('onSuccess:');
        console.log('sign up response', response);
        if (response.status == STATUS_OK){
            let accountId = response.accountId;
            dispatch( saveAccountSettings2(settings) );
            dispatch(alertSuccess(response.message));
        }else{
          alert(response.message);
          return;
        }
      },
      onFailed: (response, statusCode) => {
        console.log('onFailed:');
        dispatch( showLoadingIndicator(false) );
        alert(response.message);
        statusCode
        ? dispatch(alertFailed(response.statusText +' '+statusCode))
        : dispatch(alertFailed(response.message))
      },
      onError: (error) => {
        dispatch( showLoadingIndicator(false) );
        console.log('onError:');
        dispatch(alertFailed(error))
      }
    }
    fetchApi(dispatch, SAVE_SETTINGS_URL, params, callbacks);
  };
}


export function getSettings(accountId) {
  return function (dispatch) {
    dispatch( showLoadingIndicator(true) );
    let lang = localStorage.getItem('lang');
    let params = "accountId=" + accountId + "&lgeCode=" + lang;
    console.log("params", params);
    let callbacks = {
      onSuccess: (response) => {
        console.log('onSuccess:');
        console.log('sign up response', response);
        if (response.status == STATUS_OK){
            let settingsStr = response.settings
                            ? response.settings : '';
            let settings = JSON.parse(settingsStr);
            dispatch( saveAccountSettings( settings ) );
            //dispatch( savePhoneNumber(phoneNumber) );
        }else{
          alert(response.message);
          return;
        }
        dispatch( showLoadingIndicator(false) );
      },
      onFailed: (response, statusCode) => {
        console.log('onFailed:');
        alert(response.message);
        dispatch( showLoadingIndicator(false) );
      },
      onError: (error) => {
        console.log('onError:');
        dispatch( showLoadingIndicator(false) );
      }
    }
    fetchApi(dispatch, SETTINGS_URL, params, callbacks);
  };
}

export const saveAccountSettings = (settings) => {
  return {
    type: SAVE_ACCOUNT_SETTINGS,
      phoneNumber: settings.personal.phone,
      email: settings.personal.email,
      password: settings.personal.password,
      licensePlate: settings.personal.licensePlate
  }
}

export const saveAccountSettings2 = (settings) => {
  return {
    type: SAVE_ACCOUNT_SETTINGS2,
      email: settings.personal.email,
      password: settings.personal.password,
      licensePlate: settings.personal.licensePlate
  }
}

export const savePhoneNumber = (phoneNumber) => {
  return {
    type: SAVE_PHONE_NUMBER,
    phoneNumber: phoneNumber
  }
}

const onShowSaveAccountSettingsProgress = () => {
  return {
    type: SAVE_ACCOUNT_SETTINGS_PROGRESS
  }
}

const saveAccountSettings2Failer = () => {
  return {
    type: SAVE_ACCOUNT_SETTINGS2_FAILER
  }
}



// WEBPACK FOOTER //
// ./src/actions/settingActions.js